import { DateTime } from "luxon";

export function widgetIsoDateTimeToString(isoDateTime) {
  const dateRequested = DateTime.fromISO(isoDateTime, { zone: "utc" });

  if (dateRequested.isValid) {
    return dateRequested.toLocaleString(DateTime.DATE_MED);
  }

  return "";
}

/**
 * Closes the widget and, optionally, executes one of the available actions
 * @param {Object} options Optional props to define what happens after the widget closes
 * @param {String} options.callbackUrl Open this URL
 * @param {String} options.projectId Open this FV project
 * @param {Object} options.collectionItemId Open this FV collection item
 */
export const handleWidgetClose = (options) => {
  let callbackUrl = options?.callbackUrl;

  if (callbackUrl) {
    if (options.projectId) {
      callbackUrl = callbackUrl.replaceAll("{{projectid}}", options.projectId);
    }

    window.location.replace(callbackUrl);
  } else if (options.projectId) {
    window.location.replace(`${process.env.REACT_APP_FV_URL}/#/project/${options.projectId}`);
  } else if (options.collectionItemId) {
    window.location.replace(`${process.env.REACT_APP_FV_SHORT_LINK}/${options.collectionItemId}`);
  } else {
    window.close();
  }
};
